import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import type { Service } from '../../data/services';

/**
 * BLOCK: related_services
 * ACF layout name: `block_related_services`
 *
 * Fields:
 *  - heading  (text)
 *  - services (relationship → Service CPT; leave empty to auto-fill with
 *              "all services except the current one")
 *
 * Consolidates the identical "You might also like" grid at the foot of all
 * three service detail pages.
 */

interface RelatedServicesProps {
  heading?: string;
  services: readonly Service[];
}
export function RelatedServices({
  heading = 'You might also like',
  services
}: RelatedServicesProps) {
  if (services.length === 0) return null;
  return <section className="bg-cream-200 px-6 py-20" aria-labelledby="related-services-heading" data-id="element-163" data-mp="3hkh5j9j4j11h">
      <div className="mx-auto max-w-7xl" data-id="element-164" data-mp="10vlgjvffb44b">
        <h2 id="related-services-heading" className="mb-12 text-center font-serif text-3xl text-charcoal md:text-4xl" data-id="element-165" data-mp="wwcjohp36q4j">
          {heading}
        </h2>
        <div className="mx-auto grid max-w-4xl grid-cols-1 gap-8 md:grid-cols-2" data-id="element-166" data-mp="1fonb7j2apb40">
          {services.map(service => <Link key={service.id} to={service.link} className="group block overflow-hidden rounded-2xl bg-white shadow-soft transition-all hover:shadow-md focus:outline-none focus:ring-2 focus:ring-sage-700 focus:ring-offset-4" data-id="element-167" data-mp="1jq0k620opuf5">
              <div className="aspect-[4/3] overflow-hidden" data-id="element-168" data-mp="w0ek7cchnb63">
                <img src={service.image} alt={service.title} loading="lazy" decoding="async" width={800} height={600} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-169" data-mp="vyldjx1vkqy3" />
              </div>
              <div className="p-6" data-id="element-170" data-mp="d8vid8u7a35n">
                <h3 className="mb-2 font-serif text-xl text-charcoal" data-id="element-171" data-mp="d7txydrao4b9">
                  {service.shortTitle}
                </h3>
                <span className="flex items-center text-sm text-sage-700 transition-colors group-hover:text-sage-600" data-id="element-172" data-mp="1bmizxg5ld77r">
                  Explore
                  <ArrowRight size={14} className="ml-1" aria-hidden="true" data-id="element-173" data-mp="1pcmd7hmhtql2" />
                </span>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}